import {
  IconBarcode,
  IconHandbagSimple,
  IconShoppingCartSimple,
  Text,
} from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { Attributes, type MaxItemsPerAttribute } from 'typings'
import { Tag } from '../../../Tag'
import { RuleContent, RuleDescription, RuleIcon } from '../../RuleStack'
import { messages } from '../messages'
import { styles } from '../styles'

const iconMap = {
  [Attributes.CART]: IconShoppingCartSimple,
  [Attributes.PRODUCT]: IconHandbagSimple,
  [Attributes.SKU]: IconBarcode,
}

type IconProps = {
  attribute: Attributes
}
const Icon = ({ attribute }: IconProps) => {
  const Component = iconMap[attribute]

  if (Component) return <Component />

  return null
}

export function MaxItemsPerAttributeView(props: {
  restriction: MaxItemsPerAttribute
}) {
  const { restriction } = props

  return (
    <>
      <RuleIcon>
        <Icon attribute={restriction.attribute} />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.view.maxItemsPerAttribute}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
            attribute: restriction.attribute,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <div className={styles.detailedView}>
          <Tag>
            <FormattedMessage
              {...messages.view.items}
              values={{ value: restriction.value }}
            />
          </Tag>
          <Text variant="detail" tone="secondary">
            <FormattedMessage
              {...messages.view.AppliedTo}
              values={{
                value: restriction.value,
                applyTo: restriction.applyTo,
              }}
            />
          </Text>
        </div>
      </RuleContent>
    </>
  )
}
